// This file initializes dayjs with plugins and exports it.
import dayjs from "dayjs";

// plugins
import utc from "dayjs/plugin/utc";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import de from "dayjs/locale/de";

dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.locale(de);

export default dayjs;
